// Weight and Ave. Weight sometimes returns '~' or 'kg' in the weight,
// so this function replaces then converts
export function weightComparator(valueA, valueB) {
  const finalA = valueA ? valueA.replace(/[^0-9.]/g, "") : "0";
  const finalB = valueB ? valueB.replace(/[^0-9.]/g, "") : "0";
  return parseFloat(finalA) - parseFloat(finalB);
}
